import { startOfUtcDay, subUtcDays } from "@/lib/date-utils"

export type DateRange = {
  from: Date
  to: Date
}

/**
 * Default selections shown on the Stream Stats page's first render.
 * Shared between the page (to pre-warm/await queries) and StreamStatsContent
 * (its initial state) so both target the exact same query cache keys.
 */

/** Overview section defaults to the current month. */
export function getInitialOverviewMonth(): Date {
  return new Date()
}

/** Stream Stats section defaults to the trailing 30 days. */
export function getInitialStatsRange(now = new Date()): DateRange {
  const today = startOfUtcDay(now)
  return { from: subUtcDays(today, 29), to: today }
}
